export const MEMBERSHIP_ENUM_MAP = {
  basic: 'BASIC',
  hackster: 'HACKSTER',
  partner: 'PARTNER',
  pending: 'PENDING',
  pro: 'PRO',
  verified: 'VERIFIED',
};
